export const planets = {
  sun: "https://prod.spline.design/M8nU2QowjobvAKDI/scene.splinecode",
  mercury: "https://prod.spline.design/tBvTc-t9xsf8Cwk6/scene.splinecode",
  venus: "https://prod.spline.design/WuZOqS1iq7jOeQQV/scene.splinecode",
  earth: "https://prod.spline.design/iDOO8WXRef7JxBwM/scene.splinecode",
  moon: "https://prod.spline.design/0QyQy5xBgCa5ttBq/scene.splinecode",
  mars: "https://prod.spline.design/w6HDWnbh4Oq0qLr0/scene.splinecode",
  jupiter: "https://prod.spline.design/6VnyO2Dr7U1xkL3b/scene.splinecode",
  saturn: "https://prod.spline.design/Fzdg9kD0la2KJYxy/scene.splinecode",
  uranus: "https://prod.spline.design/j5Z-47LaEM-ZjeAI/scene.splinecode",
  neptune: "https://prod.spline.design/NGaf6N8K9jG8VeUH/scene.splinecode",
  pluto: "https://prod.spline.design/Iy782O7BL0y0IAMS/scene.splinecode",
};
